export default __webpack_public_path__ + "static/media/Beast Hunter's Reaper Crossbow.e0078c98.jpg";